export default __webpack_public_path__ + "static/media/upload.3d3488dd.svg";